module.exports = __webpack_public_path__ + "static/media/AmazingStories.6cb3c127.png";